import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileShp.tsx
const IconFileShp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ed5c91",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm2.39 6.166q-.552 0-.936-.186a2.2 2.2 0 0 1-.654-.492l.6-.606q.426.48 1.05.48.336 0 .498-.138a.46.46 0 0 0 .162-.366.43.43 0 0 0-.096-.288q-.096-.12-.39-.162l-.414-.054q-.666-.084-.978-.402-.306-.318-.306-.846 0-.282.108-.516t.306-.402q.204-.168.492-.258.294-.096.666-.096.474 0 .834.15t.618.438l-.606.612q-.15-.174-.366-.282a1.1 1.1 0 0 0-.534-.114q-.306 0-.456.108a.35.35 0 0 0-.15.3q0 .216.114.312.12.096.384.138l.414.066q.648.102.96.402.312.294.312.84 0 .3-.108.552a1.2 1.2 0 0 1-.318.432q-.204.18-.51.282a2.3 2.3 0 0 1-.696.096m2.078-.096v-4.188h.912v1.668h1.094v-1.668h.912v4.188h-.912v-1.716H15.38v1.716zm3.458.024v-4.188h1.98q.294 0 .528.102.234.096.396.27.168.174.258.426.09.246.09.54 0 .3-.09.546t-.258.42q-.162.174-.396.276a1.4 1.4 0 0 1-.528.096h-1.068v1.512zm1.872-2.304h-.96v-1.092h.96q.204 0 .318.108.12.102.12.306v.264q0 .204-.12.312a.46.46 0 0 1-.318.102",
			clipRule: "evenodd"
		})
	]
});
var IconFileShp_default = forwardRef(IconFileShp);
//#endregion
export { IconFileShp_default as default };
